import Vue from 'vue'
import Vuex from 'vuex'
import shared from './modules/shared'
import configuracoes from './modules/configuracoes'
import snackbar from './modules/snackbar'
import auth from './modules/auth'
import pedidos from './modules/pedidos'
import unidades from './modules/unidades'
import requisicoes from './modules/requisicoes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    configuracoes,
    snackbar,
    auth,
    pedidos,
    unidades,
    requisicoes,
  }
})
